<template>
<div class="farsi">
    <date-picker
    v-model="localDate"
    format="jYYYY/jMM/jDD"
    :element="id"
    input-class="farsi"
    :auto-submit="true"
    :view="view"
    :min="min"
    :max="max"
    :color="color"
    >
    </date-picker>
  
</div>
</template>

<script>
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
    export default {
        props:['id','min','max','color','date','view'],
        data(){
            return {
                localDate:this.date
            }
        },
        components: {
            datePicker: VuePersianDatetimePicker
        },
        watch:{
            localDate:function(value){
                this.$emit('updateValue',value)
            }
        }
    }
</script>